// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 657 ? "orcamento-v3" : chunkId) + "." + {"252":"6998bdd2","279":"1ae727bc","357":"4626b936","657":"ac037a7e","671":"4648b459","900":"93c0804c","971":"f6e2b2cb"}[chunkId] + ".chunk.js";
};